import React, { Component } from 'react';
import {Col, Row, Modal, OverlayTrigger, Button} from 'react-bootstrap';
import GroupFilterItemView from './GroupFilterItemView';

class GroupModalView extends Component {

    handleChange = (keyName) => {
        var group = this.props.search && this.props.search.group;
        this.props.handleChange({groupSelected: {category: group, keyName: keyName}});
    }

    renderItems() {
        var group = this.props.search && this.props.search.group;
        if (!group) {
            return;
        }
        let filteredFacet = this.props.facets[group] || {};
        let data = [];
        let facetsKeys = Object.keys(filteredFacet);
        if (facetsKeys.length === 0) {
            data.push(<div key="empty-facets" className="no-facets text-center">There are no {group} options to display</div>);
        } else {
            facetsKeys.forEach(function(key, index) {
                data.push(<GroupFilterItemView facets={this.props.facets} search={this.props.search}
                    attributeSelected={this.props.attributeSelected}
                    group={group}
                    key={index}
                    handleChange={this.handleChange} keyName={key}/>);
            }, this);
        }
        return data;
    }

    render() {
        const {groupDisplayName} = this.props;
        return (
            <Modal show={this.props.groupModalOpen} bsSize='large' onHide={this.props.toggleMenuChanged} keyboard>
                <Modal.Body className="padding-large">
                    <Modal.Header className="padding-top-none" closeButton></Modal.Header>
                    <Row className="margin-top-medium">
                        <Col xs={12} className="form-group">
                            <span className="community-sidebar-input-title input-text-uppercase color-1">{groupDisplayName}</span>
                        </Col>
                        <Col xs={12}>
                            {this.renderItems()}
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer className="padding-right-large">
                    <button className="no-style-link-button modal-close-btn" aria-label="Close"
                        onClick={this.props.toggleMenuChanged}>CLOSE
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default GroupModalView;
